export const useJournalGuide = () => useState('journal-guide-v2', () => ({active:false, step:0, owner:'', done:false, award:false}));
